import { Box, Divider, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { ORG_SUBSCRIPTION_PLANS } from "../../constants/billing";
import { useAppStore } from "../../hooks/useStores";
import { hasOrganization } from "../../utils";
import AttributionWidget from "../Dashboard/Attribution/AttributionWidget";
import LegalWidget from "../Dashboard/Legal/LegalWidget";
import styles from "./LicensedAIPage.module.scss";

const LicensedAIPage = () => {
	const { t } = useTranslation("dashboard", { keyPrefix: "licensedAIPage" });
	const { authStore } = useAppStore();
	const isPayingOrg = authStore.orgSubscription?.plan_name !== ORG_SUBSCRIPTION_PLANS.free.name;

	return (
		<Box className={styles.content}>
			<Typography variant="h3" component="h1" className={styles.title}>
				{t("title")}
			</Typography>
			<Divider className={styles.divider} />
			{hasOrganization() && isPayingOrg ? <AttributionWidget /> : <LegalWidget />}
		</Box>
	);
};

export default observer(LicensedAIPage);
